var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { Dependencies } from "~/core/decorator";
import { VePie } from "v-charts";
import { HomePageService } from '~/services/domain-service/home-page.service';
var CaseRecordChart = /** @class */ (function (_super) {
    __extends(CaseRecordChart, _super);
    function CaseRecordChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = '按金额统计';
        _this.caseRecordChart = {
            data: {
                columns: ['部门', '催收总金额'],
                rows: []
            },
            setting: {
                label: {
                    position: 'outside',
                    formatter: '{b}: {d}%'
                },
                radius: 130
            },
            legend: {
                icon: 'circle',
                itemWidth: 10,
                itemHeight: 10,
                x: 'center',
                bottom: 20
            }
        };
        return _this;
    }
    CaseRecordChart.prototype.updateData = function () {
        this.caseRecordChart.data.columns = this.type === '按金额统计' ? ['部门', '催收总金额'] : ['部门', '案件个数'];
        this.isReturnCase ? this.getReturnCase() : this.getWaitCase();
    };
    CaseRecordChart.prototype.getReturnCase = function () {
        var _this = this;
        this.homePageService.getOutCaseChart().subscribe(function (data) {
            _this.caseRecordChart.data.rows = data;
        });
    };
    CaseRecordChart.prototype.getWaitCase = function () {
        var _this = this;
        this.homePageService.getWaitCollectCaseChart().subscribe(function (data) {
            _this.caseRecordChart.data.rows = data;
        });
    };
    CaseRecordChart.prototype.mounted = function () {
        this.updateData();
    };
    __decorate([
        Dependencies(HomePageService)
    ], CaseRecordChart.prototype, "homePageService", void 0);
    __decorate([
        Prop()
    ], CaseRecordChart.prototype, "isReturnCase", void 0);
    CaseRecordChart = __decorate([
        Component({
            components: {
                VePie: VePie
            }
        })
    ], CaseRecordChart);
    return CaseRecordChart;
}(Vue));
export default CaseRecordChart;
